import moment from "moment/moment";
import { addQuestion } from "../redux/editorSlice";

export function numberToLetters(n) {
  let str = "";
  while (n > 0) {
    const remainder = (n - 1) % 26;
    str = String.fromCharCode(65 + remainder) + str;
    n = Math.floor((n - 1) / 26);
  }
  return str;
}

export function getQuestionText(question) {
  // const endsWithQuestionMark = question.trim().endsWith("?");
  // const questionText = endsWithQuestionMark
  //   ? question.trim()
  //   : question.trim() + "?";
  // return questionText;
  return question;
}

export const findById = (formData, subjects, classes) => {
  const subjectName =
    subjects?.find((s) => s.value === formData.subject)?.label || "";

  const className =
    classes?.find((s) => s.value === formData.class)?.label || "";

  return { subjectName, className };
};

export const processHeaderValidations = (categories, questions) => {
  const headerCategory =
    categories?.find((c) => c.type_id === "header") || null;
  const isHeader =
    (headerCategory &&
      questions?.find((q) => q.question_typeid === "header")) ||
    false;
  const maxMarks = headerCategory?.otherData?.formData?.maxMarks || 0;

  return { isHeader, headerCategory, maxMarks };
};

export const getCategoryMarks = (questions) => {
  const marks = questions.reduce((acc, curvalue) => {
    const marks = Number(curvalue?.marks) || 0;
    return acc + marks;
  }, 0);
  return marks;
};

export const getHeaderData = (formData) => {
  const qstnData = {
    question_id: "header",
    question_typeid: "header",
    type_name: "header",
    formData,
  };
  const categoryData = {
    type_name: "header",
    type_id: "header",
    type_title: "Header",
    otherData: { ...qstnData },
  };
  return { qstnData, categoryData };
};

export const getValidationsMessages = (
  categories,
  questions,
  maxMarks,
  isSubmitted,
) => {
  let message = "";
  let displayMessage = false;

  const filteredCategories = categories.filter(
    (c) => c.type_id !== "header" && c.display === true,
  );

  if (filteredCategories.length === 0) return { message, displayMessage };

  const totalPaperMarks = filteredCategories.reduce((acc, curCat) => {
    return acc + Number(curCat.marks || 0) * Number(curCat.questions || 1);
  }, 0);

  if (totalPaperMarks > maxMarks) {
    // message += `\n Total marks exceed the maximum allowed (${totalPaperMarks} > ${maxMarks}).`;
    message += `\nYou have exceeded the maximum marks limit. The maximum marks is ${maxMarks} and you have selected questions of ${totalPaperMarks} marks.`;
    displayMessage = true;
  }
  if (totalPaperMarks < maxMarks && isSubmitted) {
    // message += `\n Total marks are less than allowed (${totalPaperMarks} < ${maxMarks}).`;
    message += `\nThe total marks are less than the required limit. The required total is ${maxMarks} marks, but you have selected questions of only ${totalPaperMarks} marks.`;
    displayMessage = true;
  }

  filteredCategories.forEach((category) => {
    const categoryQuestionsLength = questions.filter(
      (q) => q.question_typeid === category.type_id,
    ).length;

    const requiredQuestionsLength = category.questions;

    if (categoryQuestionsLength > requiredQuestionsLength) {
      displayMessage = true;
      // message += `\n For ${category.type_name}: Question limit exceeded $(${categoryQuestionsLength} > ${requiredQuestionsLength}).`;
      message += `\nYou have selected more questions than allowed in the ${category.type_name} section. The maximum allowed is ${requiredQuestionsLength} questions, but you have selected ${categoryQuestionsLength} questions.`;
    }

    if (categoryQuestionsLength < requiredQuestionsLength && isSubmitted) {
      displayMessage = true;
      // message += `\n For ${category.type_name}: Selected questions less than required (${categoryQuestionsLength} < ${requiredQuestionsLength}).`;
      message += `\nYou have selected fewer questions than required in the ${category.type_name} section. The required number is ${requiredQuestionsLength}, but you have selected only ${categoryQuestionsLength} questions.`;
    }
  });

  return { message, displayMessage };
};

export const getCreatePaperBody = (
  formData,
  questions,
  categories,
  userId,
  subjects,
  classes,
) => {
  // const formData = formDataa;
  const type = formData.type === "Question paper" ? 1 : 2;

  const { subjectName, className } = findById(formData, subjects, classes);

  const body = {
    type,
    form_data: { ...formData, subjectName, className },
    created_by: userId,
    header_data: processHeaderData(questions),
    questions: processQuestionstoSave(questions),
    categories: processCategoriestoSave(categories),
  };

  return body;
};

const processCategoriestoSave = (categories) => {
  return categories.map((c) => ({ ...c, catQstns: [] }));
};

const processQuestionstoSave = (questions) => {
  return questions
    .filter((q) => q.question_id !== "header")
    .map((question, index) => ({
      question_id: question.question_id,
      order: index + 1,
      marks: 0,
      ...(question.question_master_type === "school" && {
        question_type: "school",
      }),
    }));
};

const processHeaderData = (questions) => {
  const header = questions.find((q) => q.question_id === "header");
  const headerData = header ? header : "header_data";
  return headerData;
};

export const ProcessPapersData = (data, navigate, onPublishClick, onUnpublishClick) => {
  let userData = {};
  try {
    userData = JSON.parse(localStorage.getItem("userData") || "{}");
  } catch (e) {
    userData = {};
  }
  const isCoaching = String(userData?.payments?.[0]?.plan_type || "").toLowerCase() === "coaching";

  const processedData =
    data?.records?.map((paper, i) => {
      const formData = JSON.parse(paper.form_data || "{}");
      const isPublished = Boolean(paper.exam_id || paper.lms_exam_question_paper_id);

      return {
        sno: i + 1,
        examName: formData.examName,
        subject: formData.subject,
        subjectName: formData.subjectName,
        class: formData.class,
        className: formData.className,
        maxMarks: formData.maxMarks,
        created_at: moment(paper.created_at).format("DD-MM-YY HH:mm A"),
        actions: (
          /* 
          type 1 - view
          type 2 - edit
          */
          <span className="d-flex gap-2 align-items-center">
            <i
              className="fas fa-eye blue-icon my-question-view-step"
              style={{ cursor: "pointer" }}
              title="View"
              onClick={(e) => {
                e.preventDefault();
                navigate("/createPaper", {
                  state: {
                    paperId: paper.id,
                    type: 1,
                  },
                });
              }}
            ></i>
            <i
              className="fas fa-edit green-icon my-question-edit-step"
              style={{ cursor: "pointer" }}
              title="Edit"
              onClick={(e) => {
                e.preventDefault();
                navigate("/createPaper", {
                  state: {
                    paperId: paper.id,
                    type: 2,
                  },
                });
              }}
            ></i>
            {isCoaching && (
              isPublished ? (
                <button
                  type="button"
                  className="btn btn-sm btn-danger py-0 px-2"
                  style={{ fontSize: "12px", borderRadius: "4px" }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (onUnpublishClick) onUnpublishClick(paper);
                  }}
                >
                  Unpublish
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-sm btn-primary py-0 px-2"
                  style={{ fontSize: "12px", borderRadius: "4px" }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (onPublishClick) onPublishClick(paper);
                  }}
                >
                  Publish
                </button>
              )
            )}
          </span>
        ),
      };
    }) || [];
  return processedData;
};
export const mapQuestionResponse = (data) => {
  return {
    ...data,
    question_master_type: "school",
  };
};

export const handleFinalQuestionPayload = (payload, dispatch) => {
  const finalPayload = {
    ...payload,
    processed: true,
  };
  dispatch(addQuestion(finalPayload));
};

export const selectLoader = (loader) => (loader ? "skeleton" : "");

export const downloadBlob = (blobData, filename) => {
  const url = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
};

export const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date()
    .toISOString()
    .replace(/[-:.TZ]/g, "")
    .slice(0, 14);

  return `${baseName}-${timestamp}.${extension}`;
};
